import { cva } from 'class-variance-authority';

const footerClass = cva('card-footer', {
    variants: {
        justify: {
            center: ['justify-center'],
            end: ['justify-end'],
        },
    },
    defaultVariants: {
        justify: 'end',
    },
});

export const Card = ({ children }) => {
    return <div className="card">{children}</div>;
};

export const CardHeader = ({ children, ...props }) => {
    const { heading, image, button } = props;

    if (heading || image) {
        return (
            <div className="card-header">
                <div className="row items-center justify-between">
                    {heading && (
                        <div className="col w-auto">
                            <h3>{heading}</h3>
                        </div>
                    )}
                    {image && (
                        <div className="col w-auto">
                            <img src={image} className="h-8" />
                        </div>
                    )}
                    {button && <div className="col w-auto">{button}</div>}
                </div>
            </div>
        );
    }

    return <div className="card-header">{children}</div>;
};
export const CardBody = ({ children, className }) => {
    if (children == undefined) {
        return '';
    }

    return <div className={'card-body ' + className}>{children}</div>;
};

export const CardFooter = ({ children, ...props }) => {
    const { justify } = props;

    if (children == undefined) {
        return '';
    }

    return <div className={footerClass({ justify })}>{children}</div>;
};
